/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { Project } from './Project';
import {
    ProjectFromJSON,
    ProjectFromJSONTyped,
    ProjectToJSON,
    instanceOfProject,
} from './Project';

/**
 * 
 * @export
 * @interface ListProjectsResponseContent
 */
export interface ListProjectsResponseContent {
    /**
     * 
     * @type {Array<Project>}
     * @memberof ListProjectsResponseContent
     */
    projects?: Array<Project>;
}


/**
 * Check if a given object implements the ListProjectsResponseContent interface.
 */
export function instanceOfListProjectsResponseContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function ListProjectsResponseContentFromJSON(json: any): ListProjectsResponseContent {
    return ListProjectsResponseContentFromJSONTyped(json, false);
}

export function ListProjectsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListProjectsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'projects': !exists(json, 'projects') ? undefined : ((json['projects'] as Array<any>).map(ProjectFromJSON)),
    };
}

export function ListProjectsResponseContentToJSON(value?: ListProjectsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'projects': value.projects === undefined ? undefined : ((value.projects as Array<any>).map(ProjectToJSON)),
    };
}

